export function showMoreCases() {
    const casesWrapper = document.querySelector('.js-casesWrapper');
    const casesShowBtn = document.querySelector('.js-casesShowBtn');

    if (!casesWrapper) {
        return false;
    }

    const casesItems = casesWrapper.querySelectorAll('.js-casesItem');

    if (casesItems.length <= 3) {
        return false;
    }

    casesItems.forEach( (item, index) => {
        if (index <= 2) {
            return false
        }

        item.classList.add('is-hidden');
    });

    casesShowBtn.addEventListener('click', () => {

        casesItems.forEach( (item, index) => {
            if (index <= 2) {
                return false
            }

            item.classList.toggle('is-hidden');
        });

        casesShowBtn.classList.toggle('is-active');

        let btnText = casesShowBtn.classList.contains('is-active') ? 'Скрыть' : 'Посмотреть ещё дела';
        casesShowBtn.textContent = btnText;
    });

}